import React, { Component, Fragment } from 'react';
import _ from 'lodash';
import { $ } from 'rype-bootstrap';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { browserHistory, Link } from 'react-router';
import { setBookingData, purchaseTrialCredit } from 'actions/userActions';
import { injectStripe } from 'react-stripe-elements';

import Avatar from 'components/Avatar/Avatar';
import Loading from 'components/Loading/Loading';
import PaymentForm from 'components/forms/PaymentForm';
import SatisfactionGuarantee from 'components/SatisfactionGuarantee';

import StripeDefaultCardSelector from 'selectors/StripeDefaultCardSelector';
import { fetchStripeCustomer } from 'actions/stripeCustomerActions';

import '../style.css';

class BuyTrialCreditModalInner extends Component {
  constructor(props) {
    super(props);
    this.state = { editCreditCard: false };
  }

  componentDidMount() {
    if (_.isEmpty(this.props.stripeCustomer) && this.props.user) {
      this.props.fetchStripeCustomer(this.props.user.stripeCustomerId);
    }
  }

  close = () => {
    // Call 'hide' to reset all the Bootstrap styling
    $('#buy-trial-credit-modal').modal('hide');
  };

  purchase = async () => {
    this.setState({ loading: true });
    const res = await this.props.purchaseTrialCredit();
    this.setState({ loading: false });
    const { modalProps } = this.props;
    modalProps.onPurchased();
    this.close();
  };

  skipTrial = (event) => {
    event.preventDefault();
    this.props.setBookingData(this.props.modalProps.bookingData);
    browserHistory.push('/activate?plan=language_4_8pr&src=skipTrialModal');
    this.close();
  };

  renderPaymentMethod() {
    const { defaultCard, stripeCustomer } = this.props;
    const name = defaultCard ?
      `Visa ending in ${defaultCard.last4}` :
      'No active payment method';
    const buttonText = defaultCard ? 'Edit' : 'Add';

    if (stripeCustomer.status === 'loading') {
      return <Loading />;
    }

    return this.state.editCreditCard || !defaultCard ? (
      <div>
        <PaymentForm
          hidePostalCode
          hasCards
          hideFieldName
          onChange={(changeObject) => this.setState({
            cardInfoChanged: changeObject,
          })}
        />
        {defaultCard && (
          <Link
            to="#"
            className="text-underline cancel-edit-card"
            onClick={(e) => {
              e.preventDefault();
              this.setState({
                editCreditCard: false,
              });
            }}
          >
            &laquo; {name}
          </Link>
        )}
      </div>
    ) : (
      <div className="d-flex align-items-center justify-content-between">
        <div>{name}</div>
        <div className="input-group-append">
          <button
            className="btn btn-outline-secondary text-black input-append-button"
            type="button"
            onClick={() => {
              this.setState({
                editCreditCard: true,
              });
            }}
          >
            {buttonText}
          </button>
        </div>
      </div>
    );
  }

  render() {
    const { teacher, bookingData } = this.props.modalProps;
    const { loading } = this.state;
    const { services } = this.props;
    const service = Object.values(services).find(service => service.id === bookingData.serviceId);
    return (
      <div
        id="buy-trial-credit-modal"
        className="buy-trial-credit-modal modal fade"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="buy-trial-credit-label"
        aria-hidden="true"
        data-backdrop="true"
      >
        <div className="modal-dialog pt-0 pb-3 mx-auto" role="document">
          <div className="mx-auto d-flex flex-column align-items-center avatar-container">
            <Avatar
              className="pb-0"
              imageClassName="rounded-circle modal-avatar avatar border-0"
              src={teacher.imageUrl}
              alt={teacher.name}
            />
            <span className="modal-rating-container badge d-flex align-items-center justify-content-center">
              <img className="m-auto" width={14} src="/assets/star.png" />
              <span className="pl-1 modal-teacher-rating">
                {teacher.rating}
              </span>
            </span>
          </div>
          <div className="modal-content">
            <div className="modal-body p-0 mt-3">
              <div className="m-3 m-sm-5 d-flex flex-column">
                <h5 className="pt-0 align-self-center m-0">{teacher.name}</h5>
                <div className="language-title align-self-center pt-1">{service.description} Lesson </div>
                <div className="align-self-center font-weight-bold text">
                  {bookingData.startDateTime.format('dddd, MMMM Do')} at{' '}
                  {bookingData.startDateTime.format('hh:mmA')}
                </div>
                <h3 className="align-self-center font-weight-bold pt-3">
                  Trial Lesson
                </h3>
                <div className="w-100">
                  <div className="form-group">
                    <div className="d-flex flex-row justify-content-between align-items-center">
                      <label
                        className="text my-3 font-weight-bold"
                        htmlFor="textarea"
                      >
                        Pay with
                      </label>
                    </div>
                    <div className="mb-2">{this.renderPaymentMethod()}</div>
                    <hr />
                    <div className="font-weight-bold pb-3">
                      Total: $5.00 USD
                    </div>
                  </div>
                </div>
                <div className="d-flex justify-content-around">
                  {loading ? (
                    <Loading />
                  ) : (
                    <button
                      type="button"
                      id="confirm-pay-btn"
                      className="btn btn-primary btn-cursor w-100 btn-lg d-flex align-items-center justify-content-center"
                      onClick={this.purchase}
                      disabled={loading}
                    >
                      <img
                        style={{ width: 13, height: 17 }}
                        id="lock-invert"
                        className="mr-2 mb-1"
                        src="/assets/lock-white.png"
                        alt="lock"
                      />
                      <div>Claim Trial Lesson</div>
                    </button>
                  )}
                </div>
                <Link
                  to="#"
                  className="text-underline m-auto pt-3"
                  onClick={this.skipTrial}
                >
                  Skip trial lesson and subscribe to a plan
                </Link>
              </div>
            </div>
          </div>
          <div className="mt-4 satisfaction-wrap">
            <SatisfactionGuarantee />
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    modalProps: state.visibleModal.props,
    user: state.user.profile,
    stripeCustomer: state.stripeCustomer,
    defaultCard: StripeDefaultCardSelector(state),
    services: state.services,
  };
}

export default compose(
  injectStripe,
  connect(mapStateToProps, {
    purchaseTrialCredit,
    setBookingData,
    fetchStripeCustomer,
  })
)(BuyTrialCreditModalInner);



// WEBPACK FOOTER //
// ./src/components/modals/BuyTrialCreditModal/BuyTrialCreditModalInner/index.js